import MiddleBanner from "./MiddleBanner";

export default MiddleBanner;
